import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { initiateIntercomConnection } from '../utils/intercom';
import { useClouderHomePath, useVerifyAuthorization } from '../hooks';
import { SmallSpinner } from '../features/common';

function AuthorizedLoginRedirect() {
  const { homePath, isLoading } = useClouderHomePath();

  if (isLoading) {
    return <SmallSpinner />;
  }

  return <Navigate to={homePath} replace />;
}

const PrivateRoute = ({ module }) => {
  const { isVerifying, isAuthorized } = useVerifyAuthorization();

  useEffect(() => {
    if (isAuthorized) {
      initiateIntercomConnection();
    }
  }, [isAuthorized]);

  if (isVerifying) {
    return null;
  }

  if (module === 'login') {
    return isAuthorized ? <AuthorizedLoginRedirect /> : <Outlet />;
  }

  return isAuthorized ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
